<template>
  <div class="groupTerms">
    <i class="material-icons" @click="closeGroupTerms">close</i>
    <h3 class="heading">ग्रुप बनाने के नियम और शर्तें </h3>
    <ul>
      <li>★ कुल {{$props.minOrderData}} लोगों की खरीद पर यह ग्रुप डील मिलेगी</li>
      <li>★ डील कीमत का पेमेंट करना पहले ज़रूरी है</li>
      <li>★ अगर ग्रुप डील पूरी नहीं होती, तो पूरा पेमेंट आपके अकाउंट में रीफंड हो जाएगा</li>
      
    </ul>
    <div class="term_button">
      <button type="button" class="proceed_button" @click="createGroup()">
        आगे बढ़ें 
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupTerms",
  props: {
    minOrderData :{
      type: String
    }
  },
  data() {
    return {
      close: false,
    };
  },
  methods: {
    closeGroupTerms() {
      this.$emit("closeGroupTerms", false);
    },
    createGroup() {
      clevertap.event.push("CREATE_GROUP");
      try {
        console.log(this.$route.query.itemId);
        JSBridgePlugin.shoppingGroupCreate(this.$route.query.itemId);
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>